// extracted by mini-css-extract-plugin
export default {"modal":"SynonymsModal_modal__HMYWp","content":"SynonymsModal_content__oHmPd","table":"SynonymsModal_table__KaPhx","cell":"SynonymsModal_cell__DSxFC"};